import request from "@/utils/request";

/**
 * @description: 各种操作
 * @Author: sunxiaomei
 * @param {*} url
 * @param {*} data
 * @return {*}
 */
export function methodPostApi(url, data) {
  return request({
    url: url,
    method: 'post',
    data: data
  })
}
/**
 * @description: 各种操作
 * @Author: sunxiaomei
 * @param {*} url
 * @param {*} data
 * @return {*}
 */
export function methodGetApi(url, params) {
  return request({
    url: url,
    method: 'get',
    params: params
  })
}
